import { useSearchParams, useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/utils";
import styles from "./Result.module.css";
import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import ProductCard from "../.shared/ProductCard/ProductCard";

export default function Result() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const medication = searchParams.get("medication");
    const frequency = searchParams.get("frequency");

    return (
    <>
        <div className={styles.resultPageContainer}>

            <Header />

            <div className={styles.title}>
                <span className={styles.congratsText}>Congrats! </span><span>You've been matched to </span>
                <span className={styles.resultText}>{capitalizeFirstLetter(medication)} {capitalizeFirstLetter(frequency)}</span>
            </div>
            <span className={styles.subTitle}>Most People Lose {medication === 'semaglutide' ? '15-17%' : '21-23%'} of Their Body Weight!</span>

            <div className={styles.resultDisplay}>

                {/* Render component based on medication and frequency searchParams */}
                <ProductCard medication={capitalizeFirstLetter(medication)} defaultFrequency={frequency}/>

                <div className={styles.resultAdditionalInfo}>
                    {medication === 'semaglutide' ? <span className={styles.resultInfo}>*Semaglutide is a GLP-1 receptor agonist, the same active ingredient in Ozempic® and Wegovy®.</span> : <span className={styles.resultInfo}>*Tirzepatide is a GLP-1/GIP receptor agonist, the same active ingredient in Mounjaro® and Zepbound®†.</span>}
                    <span>It's available by prescription only as an injectable (shots) or oral suspension (drops under your tongue).</span>
                </div>

            </div>

            <button className={styles.seeAllPlansButton} onClick={() => navigate('/programs')}>See All Plans</button>

            <div className={styles.programsInfo}>

                <div className={styles.programsInfoContainer}>

                    <span className={styles.programsInfoTitle}>Program Requirements</span>

                    <span className={styles.programsInfoSubtitle}>BMI Qualifications</span>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Standard Program: BMI of 27 or greater for full dose options</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Modified Program: BMI 25-27 with limited dose options available</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Maintenance: Low-dose maintenance available when BMI reaches 24</span>
                    </div>

                    <span className={styles.programsInfoSubtitle}>Medical Screening</span>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Comprehensive medical history review by licensed clinician</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Evaluation of current medications and health conditions</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Assessment of contraindications and safety factors</span>
                    </div>
                    <div className={styles.bullet}>
                        <div className={styles.check}></div>
                        <span>Determination of appropriate medication and dosing plan</span>
                    </div>

                </div>

                <div className={styles.programsInfoContainer}>

                    <span className={styles.programsInfoTitle}>All Programs include</span>

                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Same price for all dosage levels</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Consultation with a clinician</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Assignment of a Patient Care Coordinator</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Prescription for a GLP-1 agonist</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Access to your clinician between consultations</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Monthly check-ins and follow-ups</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Assignment of a Patient Care Coordinator</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Free shipping to your door</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Plans renew automatically</span>
                    </div>
                    <div className={styles.featureBullet}>
                        <div className={styles.check}></div>
                        <span>Money back guarantee if you do not qualify for a prescription</span>
                    </div>

                </div>

            </div>

            <div className={styles.FAQSection}>
                <div className={styles.FAQContainer}>
                    <span className={styles.FAQTitle}>Have questions about our programs?</span>
                    <button className={styles.FAQButton} onClick={() => navigate('/knowledge-center')}>Visit our FAQ Section</button>
                    <span className={styles.FAQDescription}>for detailed answers about GLP-1 medications, dosage, side effects, and more.</span>
                </div>
            </div>

            <div className={styles.additionalInfoSection}>
                <span className={styles.additionalInfoText}>All patients undergo a thorough medical evaluation to ensure GLP-1 therapy is safe and appropriate. If you are determined ineligible for a prescription after clinical assessment, you will receive a full refund.</span>
                <span className={styles.additionalInfoText}>†Ozempic® and Wegovy® are registered trademarks of Novo Nordisk A/S. Mounjaro® and Zepbound® are registered trademarks of Eli Lilly and Company. These trademark holders are not affiliated with and do not endorse TB2 Health.</span>
                <span className={styles.additionalInfoText}>Our telehealth weight loss programs are designed to help you achieve your weight loss goals safely and effectively. Programs are subscription-based, with either monthly or quarterly recurring payments. They include a consultation with a Clinician licensed in your state assisted by a Patient Care Coordinator, whom you can contact with any questions or concerns at any time. Depending on the regulations in your state, this may include a call or video visit. Based on information gathered during your consultation and your choices, the Clinician may prescribe a GLP-1 agonist that is right for you. Your Patient Care Coordinator will help you with any questions you may have about your prescription, including how to use it and how to manage any side effects. If you are determined ineligible for a prescription, you will receive a full refund. New patients typically start with a lower dose and increase over time until they find the dosage that is most effective for them. Patients who have taken GLP-1s before may be able to start at a higher dose. Talk to your clinician about what is best for you. Monthly check-ins and follow-ups are included. Cancel at any time.</span>
            </div>

        </div>
        <Footer />
    </>
    )
}